import { Component } from '@angular/core';

@Component({
  selector: 'app-koordinaten-hilfe-dialog',
  templateUrl: './koordinaten-hilfe-dialog.component.html',
  styleUrls: ['./koordinaten-hilfe-dialog.component.css']
})
export class KoordinatenHilfeDialogComponent {
}